module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c('loading', {
    attrs: {
      "position": "fixed"
    },
    model: {
      value: (_vm.isLoading),
      callback: function($$v) {
        _vm.isLoading = $$v
      },
      expression: "isLoading"
    }
  }), _vm._v(" "), _c('router-view', {
    staticClass: "viewbox"
  }), _vm._v(" "), _c('tabbar', [_c('tabbar-item', {
    attrs: {
      "selected": "",
      "link": "/"
    }
  }, [_c('i', {
    staticClass: "material-icons",
    slot: "icon"
  }, [_vm._v("")]), _vm._v(" "), _c('span', {
    slot: "label"
  }, [_vm._v("Home")])]), _vm._v(" "), _c('tabbar-item', {
    attrs: {
      "link": "/search"
    }
  }, [_c('i', {
    staticClass: "material-icons",
    slot: "icon"
  }, [_vm._v("")]), _vm._v(" "), _c('span', {
    slot: "label"
  }, [_vm._v("search")])]), _vm._v(" "), _c('tabbar-item', {
    attrs: {
      "link": "/me",
      "show-dot": ""
    }
  }, [_c('i', {
    staticClass: "material-icons",
    slot: "icon"
  }, [_vm._v("")]), _vm._v(" "), _c('span', {
    slot: "label"
  }, [_vm._v("Me")])])], 1), _vm._v(" "), _c('router-view', {
    staticClass: "view-article",
    attrs: {
      "name": "article"
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/.11.3.4@vue-loader/lib/template-compiler?{"id":"data-v-444d167c"}!./~/.1.0.61@vux-loader/src/template-loader.js!./~/.11.3.4@vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = 108
// module chunks = 1